module.exports = __webpack_public_path__ + "img/wl.6bccf327.png";